<div class="login-holder">
  @if (!configService.isAdmin()) {
    <spb-login [style.margin-top.rem]="6"/>
  }
</div>

@if (configService.isAdmin()) {
  <div class="text-holder">
    <div class="stats">
      <spb-statistics/>
    </div>
    <div class="actions">
      <mat-form-field>
        <mat-label>Sök</mat-label>
        <input matInput
               #filterInput
               (keyup)="blancoList.items.filter = filterInput.value"
        >
      </mat-form-field>
      <button
        (click)="adminService.getApplications('active')" mat-mini-fab>
        <mat-icon>cached</mat-icon>
      </button>
    </div>
    <spb-blanco-list #blancoList/>
  </div>
}